import BaseApi from './base/BaseApi';

export default class extends BaseApi {
  static entityName = 'project_file_categories';
}
